
  import { Vue, Component, Prop } from "vue-property-decorator";
  import SkillLabel from "@/components/skills/SkillLabel.vue";

  @Component({
    components: {
      SkillLabel,
    },
  })
  export default class SkillMultiselectItem extends Vue {
    @Prop({ type: String, required: true }) readonly skillName!: string;
    @Prop({ type: String, required: true }) readonly labelText!: string;
  }
